import React from 'react';
import { ResetPasswordFirstStep } from './steps/ResetPasswordFirstStep';
import { ResetPasswordValidated } from './steps/ResetPasswordValidated';
import { ModalConfirmationContainer } from '../../../components/modal';

type Props = {
  closeModal: () => void;
  isOpen: boolean;
  'data-test-id'?: string;
};

type State = {
  isFirstStep: boolean;
};

export class ResetPasswordModal extends React.Component<Props, State> {
  static defaultProps = {
    closeModal: () => {},
    isOpen: false,
  };

  state: State = { isFirstStep: true };

  validatePasswordSent = () => {
    this.setState({ isFirstStep: false });
  };

  render() {
    const { closeModal, isOpen, ...props } = this.props;
    const { isFirstStep } = this.state;
    return (
      <ModalConfirmationContainer
        isOpen={isOpen}
        onRequestClose={closeModal}
        data-test-id={props['data-test-id']}
      >
        {isFirstStep && (
          <ResetPasswordFirstStep
            closeModal={closeModal}
            onSuccess={this.validatePasswordSent}
          />
        )}
        {!isFirstStep && <ResetPasswordValidated closeModal={closeModal} />}
      </ModalConfirmationContainer>
    );
  }
}
